import React, { useState } from "react";
import { IvSignRedirect } from "../../components/IvSignRedirect/IvSignRedirect";

export const IvSignLoginSign = () => {
  const [error, setError] = useState(null);

  const authorizeProcess = async () => {
    const params = new URLSearchParams(window.location.search);
    const transactionId = params.get("transactionid");
    const ivnosysToken = params.get("token");

    if (!transactionId) {
      setError("Missing transaction ID.");
      return;
    }

    if (!ivnosysToken) {
      setError("Missing ivnosys token.");
      return;
    }

    try {
      // Recover important data from localStorage to sessionStorage
      const token = localStorage.getItem("oauthTokenB64");

      sessionStorage.setItem(
        "AccessMethod",
        localStorage.getItem("AccessMethod")
      );
      sessionStorage.setItem("oauthTokenB64", token);
      sessionStorage.setItem(
        "appearanceConf",
        localStorage.getItem("appearanceConf")
      );
      sessionStorage.setItem(
        "showApprovals",
        localStorage.getItem("showApprovals")
      );
      sessionStorage.setItem("user", localStorage.getItem("user"));

      // Remove data from localStorage after successful authorization
      localStorage.removeItem("AccessMethod");
      localStorage.removeItem("oauthTokenB64");
      localStorage.removeItem("appearanceConf");
      localStorage.removeItem("showApprovals");
      localStorage.removeItem("user");

      // Redirect to the indicated view
      window.location.href = `/documents?ivnosysPreSignAuth=true&transactionid=${transactionId}`;
    } catch (err) {
      setError(err.message);
    }
  };

  return <IvSignRedirect error={error} callback={authorizeProcess} />;
};
